import "./styles.css"
import { BiRightArrowAlt } from "react-icons/bi"

import { useState } from "react"
import { ConfirmationModal } from "../ConfirmationModal"

export const MidiaLinks = (props) => {
  const { displayModal, setDisplayModal, spotifyLink, youtubeLink, buyLink } =
    props
  const [displayAlertYoutube, setDisplayAlertYoutube] = useState(false)

  const [displayOverlay, setDisplayOverlay] = useState(false)
  const [displayAlertBook, setDisplayAlertBook] = useState(false)
  const [displayConfirmationYoutube, setDisplayConfirmationYoutube] =
    useState(false)
  const [displayConfirmationSpotify, setDisplayConfirmationSpotify] =
    useState(false)

  function mudarEstadosSpotify() {
    setDisplayConfirmationSpotify(true)

    setDisplayOverlay(true)
  }

  function mudarEstadosYoutube() {
    setDisplayConfirmationYoutube(true)

    setDisplayOverlay(true)
  }

  return (
    <>
      <div>
        {buyLink ? (
          <div className="Alert Show">
            Realmente deseja acessar?
            <div>Você será redirecionado para outro site.</div>
            <div className="botoes">
              <button
                className="etiqueta-cancelar"
                onClick={() => setDisplayModal(!displayModal)}
              >
                Cancelar
              </button>

              <a
                href={buyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="etiqueta-prosseguir"
                onClick={() => setDisplayModal(!displayModal)}
              >
                Prosseguir
              </a>
            </div>
          </div>
        ) : (
          <div className="Modal Show">
            <div
              className={spotifyLink ? "media-link" : "media-link-inactive"}
              onClick={() => (spotifyLink ? mudarEstadosSpotify() : null)}
            >
              <img
                className="linkImage"
                src={
                  spotifyLink
                    ? "https://cdn-icons-png.flaticon.com/512/174/174872.png"
                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5JoK5qdeq5Y2KecdAAke4WgDuY3QvbzFDFoq3cCyDFBoijEE2po34xZaEIO9kimofz18&usqp=CAU"
                }
                height="30px"
              />
              <div className="child">Spotify</div>
              {spotifyLink ? <BiRightArrowAlt className="navbar-icon" /> : null}
            </div>

            <div
              className={youtubeLink ? "media-link" : "media-link-inactive"}
              onClick={() => (youtubeLink ? mudarEstadosYoutube() : null)}
            >
              <img
                className="linkImage"
                src={
                  youtubeLink
                    ? "https://cdn-icons-png.flaticon.com/512/1384/1384060.png"
                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRaD8emGd1SBKf4lKAPvyUCsnWKhhB-6ddOZg&usqp=CAU"
                }
                height="30px"
              />
              <div className="child">YouTube</div>
              {youtubeLink ? <BiRightArrowAlt className="navbar-icon" /> : null}
              <div></div>
            </div>
          </div>
        )}
      </div>
      {displayConfirmationSpotify && (
        <ConfirmationModal
          buyLink={spotifyLink}
          setDisplayModal={setDisplayModal}
          displayModal={displayModal}
        />
      )}

      {displayConfirmationYoutube && (
        <ConfirmationModal
          buyLink={youtubeLink}
          setDisplayModal={setDisplayModal}
          displayModal={displayModal}
        />
      )}
      <div
        className={`Overlay ${displayModal ? "Show" : ""}`}
        onClick={() => setDisplayModal(!displayModal)}
      />

      <div
        className={`Overlay2 ${displayOverlay ? "Show" : ""}`}
        onClick={() => setDisplayModal(!displayModal)}
      />
    </>
  )
}
